import { View } from "@/components/ui";
import { Ratings } from "@/components/ui/ratings";
import { cn } from "@/lib/utils";
import { useMemo } from "react";
import { Typography } from "../../typography";

export function VisitRatingInput({
  rating,
  onChange,
  disabled,
}: {
  rating: number;
  onChange(rating: number): void;
  disabled?: boolean;
}) {
  return (
    <View className="mx-auto flex w-full max-w-[368px] flex-col gap-6">
      <Ratings
        rating={rating}
        onClick={onChange}
        disabled={disabled}
        size={48}
        variant="yellow"
      />
      <RatingLabel rating={rating} />
    </View>
  );
}

function RatingLabel({ rating }: { rating: number }) {
  const label = useMemo(() => {
    switch (rating) {
      case 1:
        return "I regretted the booking";
      case 2:
        return "Not recommended";
      case 3:
        return "Nothing special";
      case 4:
        return "Hits the spot";
      case 5:
        return "Will 100% Rebook!";

      default:
        return "";
    }
  }, [rating]);

  return (
    <Typography
      variant="label-sm"
      className={cn(
        "text-center",
        rating > 3 ? "color-success" : "color-foreground",
      )}
    >
      {label}
    </Typography>
  );
}
